/**
 * @owner @Appboy/whats-app
 * WhatsApp Messaging Service Schema
 *
 * Shared schema for the messaging service object returned in GET responses.
 * POST requests use messaging_service_id (string) instead.
 */

import { z } from "zod";
import { common } from "../common";

export const whatsAppMessagingServiceSchema = z
  .object({
    id: common.objectId,
    name: z.string(),
    phone_numbers: z.array(
      z.object({
        display_name: z.string(),
        is_active: z.boolean(),
        phone_number: z.string(),
      })
    ),
    subscription_group: z.object({
      external_id: z.string(),
      id: common.objectId,
      link_shortening_domain: z.string(),
      name: z.string(),
    }),
  })
  .nullable()
  .optional();
